import get from 'lodash/get';

const getSettings = (state) => ({
    preferences: get(state, 'context.preferences', {}),
    messagesTexts: get(state, 'context.messagesTexts', {}),
});

export default getSettings;
